import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { UpgradePage } from 'pages/settings/pages/billing/pages/upgrade/ui/upgradePage'

export const UpgradeRouter = observer(() => {
  return (
    <Routes>
      <Route path={'/'} element={<UpgradePage />} />
    </Routes>
  )
})
